import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import ProtectedRoute from './components/ProtectedRoute';
import ScrollToTop from './components/ScrollToTop';
import HomePageNew from './pages/HomePageNew';
import HomePageNewTest from './pages/HomePageNewTest';
import HomePageTest from './pages/HomePageTest';
import SchemaValidationTest from './pages/SchemaValidationTest';
import SAPBusinessOnePage from './pages/SAPBusinessOnePage';
import WhySAPBusinessOne from './pages/WhySAPBusinessOne';
import WhySAPBusinessOneTest from './pages/WhySAPBusinessOneTest';
import ManufacturingSAPB1 from './pages/ManufacturingSAPB1';
import WholesaleDistributionSAPB1 from './pages/WholesaleDistributionSAPB1';
import ProfessionalServicesSAPB1 from './pages/ProfessionalServicesSAPB1';
import CloudHostingPage from './pages/CloudHostingPage';
import OnPremiseVsCloud from './pages/OnPremiseVsCloud';
import AscariiServiceHours from './pages/AscariiServiceHours';
import ImplementationPage from './pages/ImplementationPage';
import SupportPage from './pages/SupportPage';
import AboutUsPage from './pages/AboutUsPage';
import AscariiExperiencePage from './pages/AscariiExperiencePage';
import FAQPage from './pages/FAQPage';
import ContactPage from './pages/ContactPage';
import TermsPage from './pages/TermsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import ManagingDirectorPage from './pages/personas/ManagingDirectorPage';
import FinanceDirectorPage from './pages/personas/FinanceDirectorPage';
import ITDirectorPage from './pages/personas/ITDirectorPage';
import OperationsDirectorPage from './pages/personas/OperationsDirectorPage';
import ManufacturingDirectorPage from './pages/personas/ManufacturingDirectorPage';
import BeasManufacturingPage from './pages/BeasManufacturingPage';
import NetronicManufacturingPage from './pages/NetronicManufacturingPage';
import ProdumexWMSPage from './pages/ProdumexWMSPage';
import ProdumexScanPage from './pages/ProdumexScanPage';
import StreamPage from './pages/StreamPage';
import EPoSNow from './pages/EPoSNow';
import WhyUpgradeSAP from './pages/WhyUpgradeSAP';
import QuickStartPage from './pages/QuickStartPage';
import B1UsabilityPackagePage from './pages/B1UsabilityPackagePage';
import B1InterCompanyPage from './pages/B1InterCompanyPage';
import FocusPointPage from './pages/FocusPointPage';
import CRMForOutlookPage from './pages/CRMForOutlookPage';
import BPAPlatformPage from './pages/BPAPlatformPage';
import MagmaPage from './pages/MagmaPage';
import BlogListing from './pages/BlogListing';
import BlogArticle from './pages/BlogArticle';
import LoginPage from './pages/portal/LoginPage';
import PortalDashboard from './pages/portal/Dashboard';
import UserManagement from './pages/portal/admin/UserManagement';
import AccessRequests from './pages/portal/admin/AccessRequests';
import BlogManagement from './pages/portal/admin/BlogManagement';
import BlogEditor from './pages/portal/admin/BlogEditor';
import FAQManagement from './pages/portal/admin/FAQManagement';
import LeadManagement from './pages/portal/admin/LeadManagement';
import EmailRecipientsManagement from './pages/portal/admin/EmailRecipientsManagement';
import LandingPageManagement from './pages/portal/admin/LandingPageManagement';
import SEOManagement from './pages/portal/admin/SEOManagement';
import LandingPageRenderer from './pages/LandingPageRenderer';
import AscariiRunV2Landing from './pages/AscariiRunV2Landing';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <div className="App">
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
            {/* Portal Routes (No Header/Footer) */}
            <Route path="/portal/login" element={<LoginPage />} />
            <Route path="/portal/dashboard" element={<ProtectedRoute><PortalDashboard /></ProtectedRoute>} />
            <Route path="/portal/admin/users" element={<ProtectedRoute requireAdmin><UserManagement /></ProtectedRoute>} />
            <Route path="/portal/admin/access-requests" element={<ProtectedRoute requireAdmin><AccessRequests /></ProtectedRoute>} />
            <Route path="/portal/admin/blog" element={<ProtectedRoute requireAdmin><BlogManagement /></ProtectedRoute>} />
            <Route path="/portal/admin/blog/create" element={<ProtectedRoute requireAdmin><BlogEditor /></ProtectedRoute>} />
            <Route path="/portal/admin/blog/edit/:postId" element={<ProtectedRoute requireAdmin><BlogEditor /></ProtectedRoute>} />
            <Route path="/portal/admin/landing-pages" element={<ProtectedRoute requireAdmin><LandingPageManagement /></ProtectedRoute>} />
            <Route path="/portal/admin/faqs" element={<ProtectedRoute requireAdmin><FAQManagement /></ProtectedRoute>} />
            <Route path="/portal/admin/leads" element={<ProtectedRoute requireAdmin><LeadManagement /></ProtectedRoute>} />
            <Route path="/portal/admin/email-recipients" element={<ProtectedRoute requireAdmin><EmailRecipientsManagement /></ProtectedRoute>} />
            <Route path="/portal/admin/seo" element={<ProtectedRoute requireAdmin><SEOManagement /></ProtectedRoute>} />
            
            {/* No-nav Landing Pages (must be before /* catch-all) */}
            <Route path="/landing/ascariirun" element={<AscariiRunV2Landing />} />

            {/* Public Routes (With Header/Footer) */}
            <Route path="/*" element={
              <>
                <Header />
                <main>
                  <Routes>
                    <Route path="/" element={<HomePageNew />} />
                    <Route path="/home-test" element={<HomePageTest />} />
                    <Route path="/home-new-test" element={<HomePageNewTest />} />
                    <Route path="/schema-test" element={<SchemaValidationTest />} />
                    <Route path="/sap-business-one" element={<SAPBusinessOnePage />} />
                    <Route path="/sap-business-one/why" element={<WhySAPBusinessOne />} />
                    <Route path="/sap-business-one/why-test" element={<WhySAPBusinessOneTest />} />
                    <Route path="/sap-business-one/industries/manufacturing" element={<ManufacturingSAPB1 />} />
                    <Route path="/sap-business-one/industries/wholesale" element={<WholesaleDistributionSAPB1 />} />
                    <Route path="/sap-business-one/industries/professional-services" element={<ProfessionalServicesSAPB1 />} />
                    <Route path="/sap-business-one/for/managing-directors" element={<ManagingDirectorPage />} />
                    <Route path="/sap-business-one/for/finance-directors" element={<FinanceDirectorPage />} />
                    <Route path="/sap-business-one/for/it-directors" element={<ITDirectorPage />} />
                    <Route path="/sap-business-one/for/operations-directors" element={<OperationsDirectorPage />} />
                    <Route path="/sap-business-one/for/manufacturing-directors" element={<ManufacturingDirectorPage />} />
                    <Route path="/cloud-hosting" element={<CloudHostingPage />} />
                    <Route path="/on-premise-vs-cloud" element={<OnPremiseVsCloud />} />
                    <Route path="/services/implementation" element={<ImplementationPage />} />
                    <Route path="/services/support" element={<SupportPage />} />
                    <Route path="/why-upgrade-sap" element={<WhyUpgradeSAP />} />
                    <Route path="/quickstart-sap-business-one" element={<QuickStartPage />} />
                    <Route path="/about" element={<AboutUsPage />} />
                    <Route path="/experience" element={<AscariiExperiencePage />} />
                    <Route path="/faqs" element={<FAQPage />} />
                    <Route path="/contact" element={<ContactPage />} />
                    <Route path="/terms" element={<TermsPage />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                    <Route path="/blog" element={<BlogListing />} />
                    <Route path="/blog/:slug" element={<BlogArticle />} />
                    <Route path="/landing/:slug" element={<LandingPageRenderer />} />
                    <Route path="/products/beas-manufacturing" element={<BeasManufacturingPage />} />
                    <Route path="/products/netronic-manufacturing" element={<NetronicManufacturingPage />} />
                    <Route path="/products/produmex-wms" element={<ProdumexWMSPage />} />
                    <Route path="/products/produmex-scan" element={<ProdumexScanPage />} />
                    <Route path="/products/stream" element={<StreamPage />} />
                    <Route path="/products/quickstart-sap-business-one" element={<QuickStartPage />} />
                    <Route path="/products/epos-now" element={<EPoSNow />} />
                    <Route path="/products/b1-usability-package" element={<B1UsabilityPackagePage />} />
                    <Route path="/products/b1-intercompany" element={<B1InterCompanyPage />} />
                    <Route path="/products/focuspoint" element={<FocusPointPage />} />
                    <Route path="/products/crm-for-outlook" element={<CRMForOutlookPage />} />
                    <Route path="/products/bpa-platform" element={<BPAPlatformPage />} />
                    <Route path="/products/magma" element={<MagmaPage />} />
                  </Routes>
                </main>
                <Footer />
              </>
            } />
          </Routes>
        </BrowserRouter>
      </div>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;